module.exports = __webpack_public_path__ + "static/media/6.4decf163.jpeg";